export default __webpack_public_path__ + "static/media/before-project.ef145089.svg";